import BuyGiftCard from './BuyGiftCard';

export default BuyGiftCard;
